
import { Power4, gsap } from 'gsap';
import { Helper } from "../../utils/Helper";
import { SymbolData } from "./config/SymbolData";
import { ISymbolAnimationConf } from "./ReelBaseSymbol";
import { ISymbolConfig } from "./config/IReelSymbolStruct";
import { ReelSpriteSymbolArea, ReelSymbolStates } from "./ReelSpriteSymbolArea";
import { SpriteAnimateConfig } from '../../../game/modules/symbol/SimpleSpriteSwap';

export class ReelSpriteSymbol extends ReelSpriteSymbolArea {
    
    protected gfxTl:gsap.core.Timeline;

    constructor(ID: number, symName: string, state: string = ReelSymbolStates.NORMAL, type?: number) {
        super(ID, symName, state, type);
    }

    protected fetchMainTimeline(vars?: gsap.TimelineVars, triggerEnd: boolean = false): gsap.core.Timeline {
        return Helper.setTimeline(this._timeLine, vars, triggerEnd);
    }

    public changeState(stateConfig: ISymbolAnimationConf): gsap.core.Timeline {
        stateConfig.sizeType = stateConfig.sizeType ??  this.sizeType.value;
        if (!stateConfig.forceState && this.state.value === stateConfig.state && this.sizeType.value === stateConfig.sizeType)
            return this._timeLine ? this._timeLine : gsap.timeline();
        else
            return this.AnimateState(stateConfig);
    }

    public markNonWin(enable: boolean, alpha: number = 0.35, durr:number = 0.25): void {
        this.gfxTl = Helper.setTimeline(this.gfxTl, {onComplete:() => {this._darkSquareGfx.alpha = enable ? alpha : 0 }}, true);
        this.gfxTl.to(this._darkSquareGfx, { duration: durr, alpha: enable ? alpha : 0 });
    }

    protected AnimateState(config: ISymbolAnimationConf): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, {}, true);

        const animConf:SpriteAnimateConfig = {
            duration: config.duration ?? 0,
            ease: config.ease ? config.ease : Power4.easeInOut
        };

        const toConf: ISymbolConfig = config.sym ? SymbolData.getConfig(config.sym!) : this.symbolConfig;
        const toState: any =  this.state.value != config.state ? config.state! : this.state.value;
        const toSizeType: any = config.sizeType && this.sizeType.value != config.sizeType ? config.sizeType! : this.sizeType.value;

        const TEXTURES_TO: PIXI.Texture[] | undefined = SymbolData.getTextures(toConf.NAME, toState, toSizeType);
        if(TEXTURES_TO && this._mainSprite.mainTexture != TEXTURES_TO[0]) animConf.toTexture = TEXTURES_TO[0];

        animConf.scaling = this.ExpandConfiguration(toSizeType, config.duration ?? 0,config.ease);

        this.state.set(toState);
        if(animConf.duration && TEXTURES_TO)
            this._timeLine.add(this._mainSprite.Animate({toTexture:TEXTURES_TO[0], duration:animConf.duration, ease: config.ease ? config.ease : Power4.easeInOut}),0)
        else if(TEXTURES_TO){
            this._mainSprite.setTexture(TEXTURES_TO[0]);
        }

        this.symbolConfig = toConf;

        return this._timeLine;
    }

    ExpandConfiguration(_toSizeType:number, _duration:number,_ease?:any):{to:PIXI.Point, from:PIXI.Point} | undefined{
        if (!this.sizeType.equal(_toSizeType)){
            const currSize: number = SymbolData.fetchSizeTimesSize(this.symName, this.state.value, this.sizeType.value);
            const expectedSize: number = SymbolData.fetchSizeTimesSize(this.symName, this.state.value, _toSizeType.toString());

            const toScale: PIXI.Point = new PIXI.Point(1, expectedSize / currSize);
            const fromScale: PIXI.Point = new PIXI.Point(1, currSize / expectedSize);

            this.sizeType.set(_toSizeType);
            return { from: fromScale, to: toScale};
        }
        return undefined;
    }
}
